import dayjs from 'dayjs';
import { RootState } from 'types';
import { initialState } from '.';

export const selectCurrentUser = (state: RootState) => {
  return state?.users?.currentUser || initialState.currentUser;
};
export const selectCurrentUserId = (state: RootState) => {
  return state?.users?.currentUser?.id || undefined;
};
export const selectCurrentUserSubscription = (state: RootState) => {
  return state?.users?.currentUserSubscription || undefined;
};
export const selectNonRenewingSubscriptionExpiryDate = (state: RootState) => {
  const allPurchaseDates = state?.users?.currentUserSubscription?.allPurchaseDates;
  const oneWeekAgo = dayjs().subtract(1, 'week');

  const startDates = Object.entries(allPurchaseDates || {})
    .filter(([key]) => key.endsWith('_1w'))
    .flatMap(([, dateString]) => {
      if (!dateString) return [];
      if (dayjs(dateString).isAfter(oneWeekAgo)) return dayjs(dateString);
      return [];
    })
    .sort((a, b) => a.diff(b));

  if (startDates.length === 0) return undefined;

  return startDates[0].add(1, 'week');
};

export const selectDoesUserHaveFullAccess = (state: RootState) => {
  const hasLicenseCode = !!state?.users?.currentUser?.license_code;
  const hasLicenseExpired =
    state?.users?.currentUser?.license_code_expiry_date &&
    dayjs(state?.users?.currentUser?.license_code_expiry_date).isBefore(dayjs());

  const hasValidNonRenewableSubscription = !!selectNonRenewingSubscriptionExpiryDate(state);

  return (
    (state?.users?.currentUserSubscription?.activeSubscriptions.length || 0) > 0 ||
    (hasLicenseCode && !hasLicenseExpired) ||
    hasValidNonRenewableSubscription ||
    state?.users?.currentUser?.is_caregiver
  );
};
